import { Component, OnInit } from '@angular/core';
import { GiftCardModel, GiftCardTypesModel } from 'src/app/models/gifcardVirtual.model';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { MessageService } from 'primeng/api';
import { ImageService } from 'src/app/services/image.service';

@Component({
    selector: 'models-list',
    templateUrl: 'models-list.component.html'
})

export class ModelsListComponent implements OnInit {
    
    selectModels: GiftCardModel;
    datasourceSelectModels: GiftCardModel[] = [];
    colsTablaModels: any[]; 
    loading: boolean = false;

    constructor(private giftCardService: GifcardVirtualService, 
        private messageService: MessageService,
        private imageService: ImageService) { }

    ngOnInit() {
        this.loading = true;
        this.createColumnsTablaModels();
        this.populateSelectModels();  
        this.imageService.removeModelEdit();
     }

    createColumnsTablaModels(){
        this.colsTablaModels = [
            { field: 'ID_TYPES', header: 'ID', width: '10%'},
            { field: 'ID_TYPES_NCR', header: 'ID NCR', width: '10%' },
            { field: 'DESC_TYPES', header: 'Descripción', width: '40%' },
            { field: 'TYPE_MODEL_DESC', header: 'Tipo', width: '10%' },            
            { field: 'CREATIONDATE', header: 'Fecha Creación', width: '10%' },
            { field: 'ESTADO', header: 'Estado', width: '10%' }
        ];
    }

    populateSelectModels(){
        this.giftCardService.GetGiftCardModels().subscribe(
            (response: GiftCardModel[]) => {            
                this.datasourceSelectModels = response;     
                this.loading = false;   
            },
            (error) => {
                this.loading = false;
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar tipos locales de gift card.'});
            }
        )
    }

    editModel(model: GiftCardModel){
        this.imageService.setModelEdit(model);
    }
}